import { AppLoading, useNotificationContext } from "@4uhub/lib4uhub";
import { memo, useState } from "react";
import { createSignalRContext } from "react-signalr";

import { getTotemDevices } from "../../services/totemDevide.service";

export const SignalRContext = createSignalRContext({
  shareConnectionBetweenTab: true,
});

const SignalRProvider: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [loading, setLoading] = useState(true);

  const { setMessage } = useNotificationContext();

  const device = getTotemDevices();

  const deviceId = device?.id ?? "";

  const browserId = localStorage.getItem("browserId");

  return (
    <SignalRContext.Provider
      automaticReconnect
      url={
        process.env.REACT_APP_SIGNALR +
        "?browserId=" +
        browserId +
        "&totemDeviceId=" +
        deviceId
      }
      onError={async (error) => {
        setMessage({
          message: error?.message || "Something went wrong",
          type: "error",
        });
      }}
      connectEnabled={!!deviceId && !!browserId}
      withCredentials={true}
      onBeforeClose={async (conection) => {
        conection.stop();
      }}
      onReconnect={async (conection) => {
        setMessage({
          message: "Reconectado com sucesso",
          type: "info",
        });
      }}
      onOpen={async (conection) => {
        try {
          setLoading(false);
          setMessage({
            message: "Conectado com sucesso",
            type: "info",
          });
        } catch (error) {
          console.log(error);
          setMessage({
            message: "Something went wrong",
            type: "error",
          });
          setLoading(false);
        }
      }}
    >
      {loading ? <AppLoading /> : children}
    </SignalRContext.Provider>
  );
};

export default memo(SignalRProvider);
